<div class="modulo modulo-podcast">
    <div class="modulo-content">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <img class="phone wow slideInLeft" data-wow-delay="0.5s" src="/images/modulo/podcast/{{data.params.imagem}}" alt="Podcast Igreja Greenhouse" />
                </div>
                <div class="col-md-7">
                    <div class="box wow slideInUp" data-wow-delay="0.6s">
                        <h3>{{data.params.titulo}}</h3>
                        <article [innerHtml]="data.params.texto | safeHtml"></article>
                        <div class="embed"> 
                            <iframe [src]="link" width="100%" height="160px" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                        </div>
                        <a [href]="data.params.link" title="Podcast" target="_blank">
                            Clique Aqui
                        </a> 
                    </div>
                </div>    
            </div>    
        </div>    
    </div>    
</div>    